import { throttle } from '@/utils/throttle';
import { type EventMap, posthog_points } from './constants';
import posthog from 'posthog-js';
import { debounce } from '@/utils/debounce';

/**
 * @description 普通上报, 执行即上报
 */
export const RPostHog = (
  event: keyof EventMap,
  eventMap: EventMap[keyof EventMap]
) => {
  posthog.capture(posthog_points[event], eventMap);
};

/**
 * @description 节流上报，每次事件上报后，等待3秒才会再次上报
 */
export const RPostHogThrottle = throttle(
  (event: keyof EventMap, eventMap: EventMap[keyof EventMap]) => {
    posthog.capture(posthog_points[event], eventMap);
  },
  3000
);

/**
 * @description 防抖上报，在3秒内重复上报只会上报最后一次结果
 */
export const RPostHogDebounce = debounce(
  (event: keyof EventMap, eventMap: EventMap[keyof EventMap]) => {
    posthog.capture(posthog_points[event], eventMap);
  },
  3000
);
